module.exports = {"510811100":"元坝镇","510811101":"卫子镇","510811102":"王家镇","510811103":"磨滩镇","510811104":"柏林沟镇","510811105":"太公镇","510811106":"虎跳镇","510811107":"红岩镇","510811108":"昭化镇","510811111":"青牛镇","510811112":"射箭镇","510811113":"清水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510811.json
// module id = 2441
// module chunks = 0